import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_SectionHeader = _resolveComponent("SectionHeader")!
  const _component_SectionApresention = _resolveComponent("SectionApresention")!
  const _component_SectionSkillsTags = _resolveComponent("SectionSkillsTags")!
  const _component_SectionServices = _resolveComponent("SectionServices")!
  const _component_SectionPortfolio = _resolveComponent("SectionPortfolio")!
  const _component_SectionMyResume = _resolveComponent("SectionMyResume")!
  const _component_FooterBar = _resolveComponent("FooterBar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavBar),
    _createVNode(_component_SectionHeader),
    _createVNode(_component_SectionApresention),
    _createVNode(_component_SectionSkillsTags),
    _createVNode(_component_SectionServices),
    _createVNode(_component_SectionPortfolio),
    _createVNode(_component_SectionMyResume),
    _createVNode(_component_FooterBar)
  ], 64))
}